

const initialState = {
  layoutstyledata: localStorage.getItem("layoutStyling"),
};

export default initialState;
